<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form :model="row"
               ref="ruleForm"
               label-width="100px"
               class="demo-ruleForm">
        <!-- <el-divider v-if="row.order.total>0">确认发票信息</el-divider> -->
        <!-- <div v-if="row.order.total>0">

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                  label="发票抬头"
                  prop="fapiao_taitou"
                  :rules="[{ required: true, message: '发票抬头不能为空', trigger: 'blur' }]"
              >
                <el-input
                    v-model="row.fapiao_taitou"
                    placeholder="请输入发票抬头"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                  label="税号"
                  prop="fapiao_shuihao"
                  :rules="[{ required: true, message: '税号不能为空', }]"
              >
                <el-input
                    v-model="row.fapiao_shuihao"
                    placeholder="请输入税号"
                ></el-input>
                <div class="form-label-desc mt10">如果您所在的单位没有纳税人识别号请填写“无”</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="地址" prop="fapiao_address">
                <el-input
                    v-model="row.fapiao_address"
                    placeholder="（非必填）发票购买方地址"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                  label="电话"
                  prop="fapiao_tel"
                  :rules="[
            ]"
              >
                <el-input
                    v-model="row.fapiao_tel"
                    placeholder="（非必填）发票购买方电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="开户行及账号" prop="fapiao_account">
                <el-input
                    v-model="row.fapiao_account"
                    placeholder="（非必填）发票购买方开户行及账号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                  label="发票备注"
                  prop="fapiao_beizhu"
                  :rules="[
            ]"
              >
                <el-input
                    v-model="row.fapiao_beizhu"
                    placeholder="请输入发票备注"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                  label="接收邮箱"
                  prop="fapiao_email"
                  :rules="[
              { required: true, validator: validator.email, message: '请输入正确的邮箱' },
            ]"
              >
                <el-input
                    v-model="row.fapiao_email"
                    placeholder="请输入接收邮箱"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                  label="接送手机"
                  prop="fapiao_phone"
                  :rules="[
              { required: true, validator: validator.phone, message: '请输入正确的手机号' },
            ]"
              >
                <el-input
                    v-model="row.fapiao_phone"
                    placeholder="请输入接送手机"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div> -->
        <!-- <div class="fapiao-tip-wrap">
          <div>
            发票金额：{{
              parseInt(row.order.memberprice) + parseInt(row.order.otherprice)
            }}元 名目：培训费
          </div>
        </div> -->
        <div style="height: 0.2rem"></div>

        <el-divider>费用信息</el-divider>
          <el-col :span="12" v-for="(item, index) in row.list">
            <el-form-item :label="item.service_name + ':'" label-width="auto">
              <div>¥{{ item.price }}x{{ item.count }}</div>
            </el-form-item>
          </el-col>

        <el-col :span="12">
          <el-form-item label="费用总计:" label-width="auto">
            <div>{{ row.order.total }}</div>
          </el-form-item>
        </el-col>


        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">确定提交</el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain v-if="false">重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>

      <PayDialog
          :show="payDialogShow"
          scene="huiyi_baoming"
          :ids="orderIds"
          @onPayError="onPayError"
          @onPaySuccess="onPaySuccess"
          @onPayClose="onPayClose"
      />
    </div>
  </div>
</template>
<style scoped>

</style>
<script>
import Vue from "vue";
import area from "@/utils/area";
import validator from "../../../utils/validator";
import PicUploader from "@/components/picker/PicUploader.vue";
import FileUploader from "@/components/picker/FileUploader.vue";

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  ActionSheet,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
} from "vant";
import CaipanPicker from "@/components/picker/CaipanPicker.vue";
import FamliyPicker from "@/components/picker/FamliyPicker.vue";

import PayDialog from "@/components/PayDialog.vue";

Vue.use(Cell)
    .use(CellGroup)
    .use(Form)
    .use(Divider)
    .use(Area)
    .use(ActionSheet)
    .use(RadioGroup)
    .use(Radio)
    .use(Icon)
    .use(Toast)
    .use(Popup)
    .use(Picker)
    .use(Sidebar)
    .use(SidebarItem)
    .use(Tag)
    .use(Stepper)
    .use(Field)
    .use(Switch)
    .use(Button);
export default {
  name: "HuiyiApplyFormStep5",
  components: {
    [Field.name]: Field,
    PicUploader,
    PayDialog,
    FileUploader,
  },
  data: function () {
    return {
      validator,
      payDialogShow: false,
      saveLoading: false,
      showArea: false,
      areaList: {},
      areaValue: "",
      submitType: "",
      subjectName: "",
      orderIds: [],
      subjectArray: [],
      subjectOptions: [],
      row: {
        order: {},
        list: [],
      },
    };
  },
  filters: {},
  mounted() {
    let that = this;
    that.row.id = this.$route.query.id;
    document.title = "确认发票信息"
    if (that.row.id) {
      this.fetch();
    }
  },
  watch: {
    formData() {
    },
  },
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log("onQuestion");
    },
    goPre() {
      let that = this;
      rbLink(
          {
            name: "HuiyiApplyFormStep2",
            query: {
              id: that.row.id,
            },
          },
          "replace"
      );
    },

    submitForm(formName) {

      let that = this;
      that.formValidate = true;

      that.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          console.log(that.formData)
          that.formValidate = true;
          let valiOk = true;
          if (!valiOk) {
            return;
          }

          that.saveLoading = true;

          console.log(that.formData);
          that.formValidate = true;
          for (let field in that.formData) {
          }
          that.saveLoading = true;

          that.$api.post(
              "/api/huiyi/ordersave",
              that.row,
              (res) => {
                that.saveLoading = false;
                that.orderIds = res.data.ids;

                // todo 支付的问题如何解决？ 20211130
                return
                that.payDialogShow = true;
              },
              (res) => {
                that.$message.warning(res.msg);
                that.saveLoading = false;
              }
          );

        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    onSubmit(values) {
      this.$refs["row"].validate((vaild) => {
        if (vaild) {
          console.log("onSubmit-values", values);
          console.log("submitType", this.submitType);

          let that = this;
          console.log(that.formData);
          that.formValidate = true;
          for (let field in that.formData) {
          }
          that.saveLoading = true;

          that.$api.post(
              "/api/huiyi/ordersave",
              that.row,
              (res) => {
                that.saveLoading = false;
                that.orderIds = res.data.ids;
                that.payDialogShow = true;
              },
              (res) => {
                Toast.fail(res.msg);
                that.saveLoading = false;
              }
          );
        }
      });
    },
    save(values) {
      this.submitType = "save";
    },
    onFailed(errorInfo) {
      console.log("failed", errorInfo);
    },
    submit(values) {
      this.submitType = "submit";
    },
    fetch() {
      let that = this;
      that.$api.post(
          "/api/huiyi/step5detail",
          {
            id: that.row.id,
          },
          (res) => {
            that.row = res.data;
          },
          (res) => {
            Toast.fail(res.msg);
          }
      );
    },

    onPayError() {
      let that = this;
      console.log("onPayError 支付失败");
      that.payDialogShow = false;

      that.$toast("支付失败");

      rbLink(
          {
            name: "HuiyiApplyList",
          },
          "replace"
      );
    },
    onPaySuccess() {
      let that = this;
      console.log("onPaySuccess 支付成功");
      that.payDialogShow = false;

      setTimeout(function () {
        rbLink(
            {
              name: "HuiyiApplyFormSuccess",
              query: {
                id: that.row.id,
              },
            },
            "replace"
        );
      }, 500);
    },
    onPayClose() {
      let that = this;
      console.log("onPayClose 支付关闭");
      that.payDialogShow = false;

      rbLink(
          {
            name: "HuiyiApplyList",
          },
          "replace"
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// HuiyiApplyFormStep5.vue?c02dd9ca